import Container from 'core/display/Container'
import Spine from 'core/display/Spine'
import { signal } from 'services/SignalsService'
import { animations } from 'settings/custom/win'
import { create } from 'utils/Object'

export default class BonusMultiplierSpine extends Container {
  constructor(data) {
    super()

    this.ori = null
    this._data = data
    this.prevMultiplier = 0

    const spine = this.spine  = new Spine(create(this._data, animations.bonusMultiplier))
    this.addChild(spine)
    this.createSignal()

  }

  createSignal() {
    const self = this
    if (game.models.BonusMultiplierModel.isFS) {
      signal.on('STATE:OUT:SPIN', this.animate.bind(this))
    }
    signal.on('BONUS-MULTIPLIER-ANIM', this.animate.bind(this))
    signal.on('RESIZE', async function ({ orientation }) {
      self.ori = orientation

      self.animate()
    })
  }

  animate() {
    const multiplier = game.models.FreespinModel.get().multiplier
    const action = game.models.SpinModel.get().action

    if (action === 'fsProgressiveMultiplier') {
      this.spine.visible = true
      if (this.prevMultiplier === multiplier && !this._data.ignoreIdle) {
        const idleAnim = this._data.turnOffOri ? `x${multiplier}-idle` : `x${multiplier}-idle-${this.ori}`
        this.spine.play(idleAnim, false)
        signal.dispatch(`SOUND:MULTIPLIER:${multiplier}`)
      }
      else {
        const multiplierAnim = this._data.turnOffOri ? `x${multiplier}` : `x${multiplier}-${this.ori}`
        this.spine.setToSetupPose()
        this.spine.play(multiplierAnim, false)
        this.prevMultiplier = multiplier
        signal.dispatch(`SOUND:MULTIPLIER:${multiplier}`)
      }

    }
    else {
      this.spine.visible = false
    }
  }
}
